module.exports = __webpack_public_path__ + "img/left_nav_bg_01.c438327.webp";